import crypto from 'crypto';
import emojiRegex from 'emoji-regex';
import { useEffect, useState } from 'react';

const fontFamily =
  'Proxima Nova, proxima-nova, HelveticaNeue-Light, Helvetica Neue Light, Helvetica Neue, Helvetica, Arial, Lucida Grande, sans-serif';

function hashCode(str: string) {
  const hash = crypto.createHash('sha256');
  hash.update(`${str}`);
  const hexHash = hash.digest('hex');
  return parseInt(hexHash, 16) % 0x00ffffff;
}

function intToHex(i: number) {
  const c = (i & 0x00ffffff).toString(16).toUpperCase();

  return '00000'.substring(0, 6 - c.length) + c;
}

function isLightColor(hex: string) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  const rgb = result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : { r: 0, g: 0, b: 0 };
  const L = 0.2126 * rgb.r + 0.7152 * rgb.g + 0.0722 * rgb.b;
  return L > 179;
}

function matchEmoji(name: string) {
  const emojiMatch = emojiRegex().exec(name);
  if (!!emojiMatch && emojiMatch.length > 0) {
    return {
      isEmoji: true,
      text: emojiMatch[0]
    }
  } else {
    return {
      isEmoji: false,
      text: name
    }
  }
}

export const useIconGenerator = (name: string) => {
  const [iconData, setIconData] = useState({ backgroundColor: "white", foregroundColor: "black", fontFamily, fontSize: "", characters: '' });

  useEffect(() => {
    
    const { isEmoji, text } = matchEmoji(name);
    const backgroundColor = intToHex(hashCode(text));
    const foregroundColor = isLightColor(backgroundColor) ? '#4a5568' : '#e2e8f0';
    const characters = isEmoji ? text : text
      .split(' ')
      .slice(0, 2)
      .map(part => part.slice(0, 1))
      .join('')
      .toUpperCase();
    const fontSize = isEmoji ? "130px" : "110px";
    setIconData({ backgroundColor, foregroundColor, fontFamily, fontSize, characters });
  }, [name]);

  return [iconData];
};
